<template>
  <div class="helpinfo mx-4">
    <div class="row">
      <div class="col-12 my-2">
        <p
          class="explaintx"
          :class="{
            currentstep: step === 1,
          }"
        >
          1. Enter the amount of PUTinCoins you want to wrap. You must deposit
          the full amount, especially if it has decimals!
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-2">
        <p
          class="explaintx"
          :class="{
            currentstep: step === 2,
          }"
        >
          2. Send the said amount of PUTinCoins to the PUTinCoin address generated by
          the bridge within 1 hour and wait until the transaction has got 6 confirmations.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-2">
        <p
          class="explaintx"
          :class="{
            currentstep: step === 3,
          }"
        >
          3. Wait for the admin to verify your deposit transaction. This process
          may take up to 24 hours (but normally it is between 5 minutes and 6 hours).
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-2">
        <p
          class="explaintx"
          :class="{
            currentstep: step === 4,
          }"
        >
          4. Click the "CONTINUE" button in the popup window and you&rsquo;ll get
          redirected to MetaMask extension to mint (fetch) your wPUT tokens.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-2">
        <p
          class="explaintx"
          :class="{
            currentstep: step === 5,
          }"
        >
          5. Wrapping is completed. Find your wPUTs in your MetaMask wallet.
          This session will soon be deleted.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iswrapping: Boolean,
    step: Number,
  },
};
</script>

<style lang="scss" scoped>
.helpinfo {
  padding: 15px;
  margin-bottom: 20px;
  border: 0x solid transparent;
  border-radius: 10px;
  color: #fff;
  background-color: #000;
  border-color: #e5c300;
}

.helpbg {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 10px 5px 20px 7px;
}
.bullet {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 35px;

  color: #3cb054;
}
.explaintx {
  // padding-top: 9px;
  // padding-left: 4px;
  font-family: "Roboto", sans-serif;
  // font-style: normal;
  // font-weight: normal;
  // font-size: 14px;
  // line-height: 14px;
  font-weight: bold;
  color: #fff;
}
.currentstep {
  font-weight: bold;
}
</style>
